import { Brain, Zap } from 'lucide-react';

export default function Problem() {
  return (
    <section className="py-20 lg:py-32 bg-gradient-to-b from-white to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="mb-8 flex justify-center">
            <img
              src="/Bekannt aus copy.webp"
              alt="Bekannt aus führenden Medien"
              className="w-full max-w-2xl h-auto opacity-80"
            />
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Warum funktioniert der 7-Tage-Body-Boost so gut?
          </h2>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          <div className="space-y-4 text-lg text-gray-700">
            <p className="leading-relaxed">
              Weil dein Gehirn sich jeden Tag verändert – egal wie alt du bist. Dieser Prozess heißt <span className="font-semibold text-green-600">Neuroplastizität</span>.
            </p>
            <p className="leading-relaxed">
              Wenn du die richtigen Reize setzt, beginnt dein Gehirn ungesunde Automatismen abzubauen und neue gesunde Routinen aufzubauen.
            </p>

            <div className="space-y-2 py-4">
              <p className="flex items-start gap-2">
                <span className="text-green-600 font-bold">➡️</span>
                <span>Heißhunger wird weniger.</span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-green-600 font-bold">➡️</span>
                <span>Bewegung fühlt sich leichter an.</span>
              </p>
              <p className="flex items-start gap-2">
                <span className="text-green-600 font-bold">➡️</span>
                <span>Entscheidungen werden natürlicher – fast automatisch.</span>
              </p>
            </div>

            <p className="leading-relaxed font-semibold text-gray-900">
              Der 7-Tage-Body-Boost nutzt genau diesen Effekt:
            </p>
            <p className="leading-relaxed">
              Kurze tägliche Einheiten, klare Struktur und gezielte Impulse, damit dein Gehirn in nur einer Woche auf „gesund" umschaltet.
            </p>
            <p className="text-xl font-semibold text-green-600">
              Du kämpfst nicht mehr gegen deinen Körper – dein Körper arbeitet für dich.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4 pt-6">
            <div className="bg-green-50 p-6 rounded-xl border border-green-200">
              <Brain className="w-10 h-10 text-green-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Hack dein Gehirn</h3>
              <p className="text-sm text-gray-700">
                Dein Gehirn formt neue Verbindungen für gesunde Gewohnheiten
              </p>
            </div>

            <div className="bg-amber-50 p-6 rounded-xl border border-amber-200">
              <Zap className="w-10 h-10 text-amber-600 mb-3" />
              <h3 className="font-semibold text-gray-900 mb-2">Sofortige Energie</h3>
              <p className="text-sm text-gray-700">
                Spürbare Veränderungen bereits nach 3 Tagen
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
